<ng-container *transloco="let translate; read: 'notifications'">
    <!-- Notification Trigger Button -->
    <button mat-button (click)="openPanel()" #notificationsOrigin
        class="h-10 min-h-10 px-3 md:px-4 rounded-full bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 transition-colors">
        <div class="flex items-center justify-center space-x-2">
            <!-- Icon -->
            <mat-icon class="icon-size-5 text-gray-600 dark:text-gray-300"
                [svgIcon]="'heroicons_outline:inbox'"></mat-icon>

            <!-- Number Badge -->
            <span *ngIf="store.unreadCount() > 0"
                class="flex items-center justify-center h-5 px-2 rounded-full text-xs font-bold text-white bg-red-600 animate-pulse shadow-sm">
                {{ store.unreadCount() > 99 ? '99+' : store.unreadCount() }}
            </span>
        </div>
    </button>

    <!-- Overlay Panel -->
    <ng-template #notificationsPanel>
        <div class="flex flex-col w-screen min-w-0 sm:w-80 shadow-lg rounded-b overflow-hidden bg-card pointer-events-auto dark:bg-gray-900 border"
            style="max-height: calc(100vh - 100px);">

            <!-- Header -->
            <div class="flex items-center justify-between px-4 py-3 border-b">
                <div class="text-base font-semibold leading-tight">{{ translate('title') || 'Notifications' }}</div>
                <button *ngIf="store.unreadCount() > 0" mat-button
                    class="text-sm font-medium text-primary hover:underline px-2 h-8 min-h-8 leading-none"
                    (click)="markAllAsRead()">
                    {{ translate('mark_all_read') || 'Mark all as read' }}
                </button>
            </div>

            <!-- Content Area (Scrollable) -->
            <div class="flex flex-col overflow-y-auto">
                <ng-container *ngIf="store.notifications().length > 0; else noNotifications">
                    <div class="flex flex-col">
                        <ng-container *ngFor="let notification of store.notifications(); let last = last">

                            <!-- Notification Item -->
                            <div class="group flex items-start px-4 py-3 relative border-b transition-colors" [ngClass]="{
                                    'bg-blue-50/50 dark:bg-blue-900/10': !notification.read,
                                    'cursor-pointer hover:bg-hover active:bg-hover': !!notification.actionUrl
                                }" (click)="!!notification.actionUrl ? clickNotification(notification) : null">

                                <!-- Severity Indicator Line -->
                                <div class="absolute left-0 top-0 bottom-0 w-1"
                                    [ngClass]="getSeverityClasses(notification.severity)"></div>

                                <!-- Main Content -->
                                <div class="flex flex-col min-w-0 pl-1 w-full">
                                    <div class="flex items-center justify-between">
                                        <div class="font-medium text-sm text-gray-800 dark:text-gray-100 truncate pr-2"
                                            [ngClass]="{'font-semibold': !notification.read}">
                                            {{ notification.title }}
                                        </div>
                                        <div class="text-[11px] text-gray-500 whitespace-nowrap">
                                            {{ getRelativeTime(notification.createdDate) }}
                                        </div>
                                    </div>
                                    <div class="text-sm text-gray-600 dark:text-gray-400 mt-0.5"
                                        [ngClass]="{'line-clamp-2': true, 'pr-8': true}">
                                        {{ notification.message }}
                                    </div>
                                </div>

                                <!-- Read Indicator Dot -->
                                <div *ngIf="!notification.read"
                                    class="flex self-center ml-2 flex-0 items-center justify-center h-2 w-2 rounded-full bg-blue-600"
                                    [matTooltip]="'Unread'">
                                </div>

                                <!-- Actions shown on hover -->
                                <div
                                    class="absolute right-2 top-2 hidden group-hover:flex bg-white dark:bg-gray-800 rounded shadow-sm">

                                    <!-- Mark as Read -->
                                    <button *ngIf="!notification.read" mat-icon-button
                                        class="h-7 w-7 min-h-7 text-gray-500 hover:text-blue-600 mr-0.5"
                                        [matTooltip]="translate('mark_read') || 'Mark as read'"
                                        (click)="markAsRead(notification, $event)">
                                        <mat-icon class="icon-size-4" svgIcon="heroicons_outline:check"></mat-icon>
                                    </button>

                                    <!-- Delete -->
                                    <button mat-icon-button class="h-7 w-7 min-h-7 text-gray-500 hover:text-red-600"
                                        [matTooltip]="translate('delete') || 'Delete'"
                                        (click)="deleteNotification(notification, $event)">
                                        <mat-icon class="icon-size-4" svgIcon="heroicons_outline:trash"></mat-icon>
                                    </button>
                                </div>
                            </div>

                        </ng-container>

                        <!-- Load More -->
                        <div class="flex justify-center py-2" *ngIf="store.hasMore()">
                            <button mat-button class="text-primary" (click)="loadMore()" [disabled]="store.isLoading()">
                                {{ store.isLoading() ? '...' : (translate('load_more') || 'Load more') }}
                            </button>
                        </div>
                    </div>
                </ng-container>

                <!-- Empty State -->
                <ng-template #noNotifications>
                    <div class="flex flex-col items-center justify-center p-8 text-center sm:p-12">
                        <mat-icon class="icon-size-12 text-hint mb-4" svgIcon="heroicons_outline:bell-slash"></mat-icon>
                        <div class="text-secondary mt-1 max-w-60 tracking-tight">
                            {{ translate('no_notifications') || 'You have no notifications at the moment.' }}
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </ng-template>
</ng-container>